import { createServerFn } from "@tanstack/react-start";

export type RecentLead = {
  product: string;
  source_page: string | null;
  created_at: string;
};

export type LiveStats = {
  today: number;
  last7d: number;
  recent: RecentLead[];
};

export const getLiveStats = createServerFn({ method: "GET" }).handler(
  async (): Promise<LiveStats> => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const now = Date.now();
    const startOfTodayUtc = new Date();
    startOfTodayUtc.setUTCHours(0, 0, 0, 0);
    const sevenDaysAgo = new Date(now - 7 * 24 * 60 * 60 * 1000);

    const [todayRes, weekRes, recentRes] = await Promise.all([
      supabaseAdmin
        .from("leads")
        .select("id", { count: "exact", head: true })
        .gte("created_at", startOfTodayUtc.toISOString()),
      supabaseAdmin
        .from("leads")
        .select("id", { count: "exact", head: true })
        .gte("created_at", sevenDaysAgo.toISOString()),
      supabaseAdmin
        .from("leads")
        .select("product, source_page, created_at")
        .order("created_at", { ascending: false })
        .limit(6),
    ]);

    return {
      today: todayRes.count ?? 0,
      last7d: weekRes.count ?? 0,
      recent: (recentRes.data ?? []).map((r) => ({
        product: r.product,
        source_page: r.source_page,
        created_at: r.created_at,
      })),
    };
  },
);
